import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "warning-icon",
  "use": "warning-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"warning-icon\">\r\n\t<path d=\"M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M12,19.7c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1 c0.6,0,1.1,0.5,1.1,1.1C13.1,19.2,12.6,19.7,12,19.7z M12.6,15.5l-1.2,0L10,7.1l0,0c0,0,0-0.1,0-0.1c0-1.1,0.9-2,2-2s2,0.9,2,2 c0,0,0,0.1,0,0.1l0,0L12.6,15.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol